export default __webpack_public_path__ + "525f021ef919c6dc7f99e1e3e5a279e5.svg";